import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import {Grid, Box, Button} from '@material-ui/core';
import {Select, MenuItem, InputLabel, FormControl, FormControlLabel, Checkbox, Stack } from '@mui/material';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
// import InputAdornment from '@mui/material/InputAdornment';
// import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
// import dayjs from 'dayjs';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import UserSelect from '../agents/AgentSelect';
///import moment from 'moment';
import axios from 'axios';
import Alert from '../components/Alert';
import {getVisibility} from '../commonfun/common';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});



const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const [open, setOpen] = React.useState(false); 
  const childRefAlert = React.useRef(); 
  const childRefUser = React.useRef(); 
  ///const childRefTechnician = React.useRef();
  
  const [loadingBtn, setLoadingBtn] = React.useState(false);
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [alertMessage, setAlertMessage] = React.useState("");
  
  const [accessType, setAccessType] = React.useState(1);
  const [accessWithType, setAccessWithType] = React.useState("");
  const [accessWithNames, setAccessWithNames] = React.useState("");
  const [accessWithIds, setAccessWithIds] = React.useState("");
  
  const [subject, setSubject] = React.useState("Call: Conversational");
  const [remarks, setRemarks] = React.useState("");
  const [ownerAlias, setOwnerAlias] = React.useState("");
  const [ownerId, setOwnerId] = React.useState(0);

  const [fullDay, setFullDay] = React.useState(false);
  const [startDateTime, setStartDateTime] = React.useState(new Date());
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };


  React.useEffect(() => {	

      setSubject("Call: Conversational");
      setRemarks("");

      if(props.userObj && props.userObj.fullName){
        setOwnerAlias(props.userObj.fullName);
        setOwnerId(props.userObj.userId);
      }else{
        setOwnerAlias("");
        setOwnerId(0);
      }

      setFullDay(false);
      setStartDateTime(new Date());

      setAccessWithType("");
      setAccessWithNames("");
      setAccessWithIds("");      
      if(open){
        setAccessType(getVisibility(props.userObj.visibilityJson,'Activities'));
      }
      

	}, [props.userObj,props.dataObj,open]);

  
	function saveData(){ 

    if(!remarks){
      setSeverityAlert("error");
      setAlertMessage("Enter remarks");	
      childRefAlert.current.handleClickOpen();		
      return false;
    }

		if(remarks){ 
			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
      };

      const data = new FormData();

      data.append('relatedTo', props.relatedTo);
      data.append('relatedToId', props.relatedToId);
      data.append('relatedTitle', props.relatedTitle);
      
      if(props.relatedTo==='Account' && props.relatedToId && props.relatedToId>0){
        data.append('accountId', props.relatedToId);
      }else if(props.accountId && props.accountId>0){
        data.append('accountId', props.accountId);
      }
      
      data.append('activityType', 'Call');
      data.append('parentActivityType', 'Task');
      data.append('subject', subject);
      data.append('remarks', remarks);
      data.append('priority', 'Normal');
      data.append('status', 'Completed');
      ///data.append('cancelReason', '');

      data.append('ownerId', ownerId);
      data.append('ownerAlias', ownerAlias);

      if(fullDay){
        data.append('fullDay', 1);
      }else{
        data.append('fullDay', 0);
      }

      data.append('reminderTrigger', 0);
      ///data.append('reminderDateTime', '');
      ///data.append('startDateTime', dayjs(startDateTime).format('YYYY-MM-DD hh:mm:ss'));
      ///data.append('endDateTime', '');
      ///data.append('location', '');
      ///data.append('showMeAs', '');
 
      data.append('accessType', accessType);
      data.append('accessWithType', accessWithType);
      data.append('accessWithNames', accessWithNames);
      data.append('accessWithIds', accessWithIds);

      // var myContentFile = document.querySelector('#contentfile');
      //   data.append("contentFile", myContentFile.files[0]);

      let apiURL='/crm-create-activity';
      
      setLoadingBtn(true);
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setLoadingBtn(false);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);					
					setAlertMessage("Call log has been saved.");
          childRefAlert.current.handleClickOpen();
          props.updatedList(response.data.list);
					return false;

				}else if(response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';

				}else{
          setSeverityAlert("error");					
					setAlertMessage("Call log could not be saved.");	
          childRefAlert.current.handleClickOpen();			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setAlertMessage(""+error);			
          childRefAlert.current.handleClickOpen();	
					return false;
			})	
		}		
	}


  function userDetail(obj) {
    setOwnerId(obj.autoId);
    setOwnerAlias(obj.fullName);
  }
   
  return (
    <>
      <Dialog maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>Log a Call</DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >

                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>                          
                     
                          <Grid item md={12} xs={12} >
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Call Type</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={subject}
                                  label="Call Type"                                  
                                  onChange={event => setSubject(event.target.value)}
                                >
                                  <MenuItem value={'Call: Ringing'} >Call: Ringing</MenuItem>
                                  <MenuItem value={'Call: Not Reachable'} >Call: Not Reachable</MenuItem>
                                  <MenuItem value={'Call: Wrong Number'} >Call: Wrong Number</MenuItem>
                                  <MenuItem value={'Call: Invalid Number'} >Call: Invalid Number</MenuItem>
                                  <MenuItem value={'Call: Back Later'} >Call: Back Later</MenuItem>
                                  <MenuItem value={'Call: Disconnected'} >Call: Disconnected</MenuItem>
                                  <MenuItem value={'Call: Did not Listen Properly'} >Call: Did not Listen Properly</MenuItem>
                                  <MenuItem value={'Call: Conversational'} >Call: Conversational</MenuItem>
                                </Select>
                              </FormControl>
                          </Grid>

                          {/* <Grid item md={6} xs={12} >
                              <LocalizationProvider dateAdapter={AdapterDayjs}  >
                                <Stack spacing={1} >
                                    <DateTimePicker                                                                             
                                      value={startDateTime}
                                      onChange={val => setStartDateTime(val)}
                                      renderInput={(params) => <TextField {...params} size="small" label={'Date/Time'} />}
                                      minDate={new Date()}
                                      inputFormat="DD-MM-YYYY hh:mm a"                                      
                                    />                                  
                                </Stack>
                              </LocalizationProvider>
                          </Grid> */}

                          <Grid item md={12} xs={12} >
                              <TextField label="Remarks" onChange={event => setRemarks(event.target.value)} value={remarks} fullWidth variant="outlined" multiline size="small" rows={3} />
                          </Grid>                



                    </Grid>

                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {loadingBtn?
                            <LoadingButton
                              loading
                              loadingPosition="start"			
                              startIcon={<div style={{marginRight:15}}></div>}								
                              variant="outlined"
                              color="secondary"
                              id="waitloginbtnid" 
                              style={{width: 110, backgroundColor:'#008000',color:'#FFF',marginRight:10}}
                            >
                              Saving...
                            </LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }    
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
      <Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} /> 
      <UserSelect userObj={props.userObj} fetchDetail={userDetail} fetch={true} ref={childRefUser} />
        
    </>
  );

});

export default CustomizedDialogs;